@for (layer of layers; track layer.id) {
  <div class="pm-layer  mb-2 ">
    <div class="d-flex justify-content-between align-items-center">
      <b>{{layer.name}}</b>
      <div>
        <mat-slide-toggle (change)="handleLayerVisibility(layer)" [checked]="layer.active"/>
      </div>
    </div>

    @if (layer.updateIconSize) {
      <mat-form-field appearance="outline" class="w-100 mt-3">
        <mat-label>Taille des pictos</mat-label>
        <input matInput type="number"
               [(ngModel)]="layer.iconSize"
               (ngModelChange)="updateIconSize(layer, $event)"
               [max]="60"
               [min]="10"
               [pattern]="'^[0-9]*$'"
               required name="size">
      </mat-form-field>

      @if (layer.iconSize < 10 || layer.iconSize > 60) {
        <div class="text-danger mt-1">La taille de l'icône doit être comprise entre 10 et 60.</div>
      }
    }

    @if (layer.entities && layer.id === 'picto') {
      <div class="mt-2 cursor-pointer" (click)="collapsed = !collapsed">
        Filtrage avancé <i class="bi bi-caret-{{collapsed ? 'up' : 'down' }}"></i>
      </div>
      @if (collapsed) {
        <div class="mt-3 mb-1">
          <map-picto-plan-filter [layer]="layer" />
        </div>
      }
    }

    @if (layer.loadType === LayerLoadType.Manual) {
      <div class="mt-1">
        <button class="pm-btn d-flex align-items-center" [disabled]="layer.isLoading" (click)="layer.loadData(true)">
          @if (layer.isLoading) {
            <mat-spinner class="me-2 d-inline-block align-middle" [diameter]="16"></mat-spinner>
          } @else {
            <i class="bi bi-stack me-2"></i>
          }
          Charger le calque
        </button>
      </div>
    }

    @if (layer.toggleLabels || layer.setLabel || layer.setDetailVisible) {
      <div class="mt-3 mb-2"><b>Options d'affichage</b></div>
    }

    @if (layer.toggleLabels) {
      <div class="mt-1 d-flex align-items-center justify-content-between">
        <mat-label>Afficher les labels</mat-label>
        <mat-checkbox
          name="layer_label"
          [disabled]="layer.dataSource.entities.values.length === 0"
          (change)="layer.toggleLabels()"
          [checked]="layer.labelVisible">
        </mat-checkbox>
      </div>
    }

    @if (layer.setLabel) {
      <div class="mt-1">
        <mat-form-field appearance="outline" class="w-100 mt-3">
          <mat-label>Distance entre les labels</mat-label>
          <input matInput type="number"
                 [value]="layer.labelDistance"
                 (change)="layer.setLabel($event.target?.value)"
                 [disabled]="layer.dataSource.entities.values.length === 0"
                 name="label_distance">
        </mat-form-field>
      </div>
    }

    @if (layer.setDetailVisible) {
      <div class="mt-1 d-flex align-items-center justify-content-between">
        <mat-label>Afficher les détails</mat-label>
        <mat-checkbox
          name="layer_label"
          [disabled]="layer.dataSource.entities.values.length === 0"
          (change)="layer.setDetailVisible(!layer.detailVisible)"
          [checked]="layer.detailVisible">
        </mat-checkbox>
      </div>
    }
  </div>
}
